import React from 'react';
import { Button } from '../../../shared';
import { BUTTON } from '../../../../constants';

/**
 * DeleteBatchPopup - Confirmation popup for batch deletion
 * @param {Function} apiCall - Function to call when confirmed
 * @param {Function} setOpenConfirmationBox - Function to control popup visibility
 */
export const DeleteBatchPopup = ({ apiCall, setOpenConfirmationBox }) => {
  const closePopUp = () => {
    setOpenConfirmationBox(false);
  };

  const handleApiCall = () => {
    setOpenConfirmationBox(false);
    apiCall();
  };

  return (
    <>
      <div className="d-flex m-1 ">
        <div className="w-25 modal-body py-0 d-flex justify-content-center align-items-center">
          <span className="d-flex justify-content-center align-items-center bg-info badge">!</span>
        </div>
        <div className="w-75 modal-body py-0">
          <h4 className=" text-center text-special mb-3 ">Delete Cut Report</h4>
          <p className="text-center text-special placeholder-color ">
            Are you sure to Delete Cut Report?
          </p>
        </div>
      </div>
      <hr />
      <div className="pb-3 mt-2 d-flex align-items-center justify-content-end mx-4  modal-btn custom-button">
        <div className="ms-5 ps-5 w-50 d-flex align-items-center justify-content-between">
          <Button
            clickHandler={handleApiCall}
            className="border-0 blue-btn d-flex align-items-center justify-content-center py-2 px-3">
            {BUTTON.CONFIRM}
          </Button>{' '}
          <Button
            clickHandler={closePopUp}
            className="border-0 blue-btn d-flex align-items-center justify-content-center py-2 px-3">
            {BUTTON.CLOSE}
          </Button>
        </div>
      </div>
    </>
  );
};
